/**
 * 官网账号产品对比表格数据配置 - 多语言支持
 * 返回根据当前语言动态生成的产品数据
 */

import i18n from '../i18n';

// 获取翻译后的频率限制文本
const getFrequencyLimitText = (type, params = {}) => {
  return i18n.t(`productComparison.frequencyLimits.${type}`, params);
};

// 获取分组的官网产品对比数据（支持多语言）
export const getGroupedOfficialProductComparisonDataI18n = () => {
  const t = i18n.t.bind(i18n);
  
  return {
    productName: 'ChatGPT Plus',
    loginMethods: [
      t('productComparison.officialTable.loginMethods.gptWebsite', 'GPT官网'),
      t('productComparison.officialTable.loginMethods.appClient', 'APP客户端')
    ],
    afterSales: t('productComparison.officialTable.afterSales.accountReplacement', '封号包换新账号'),
    officialPriceValue: '20',
    officialPricePeriod: t('productDetail.common.duration.month'),
    variants: [
      {
        id: 'official-exclusive',
        type: t('homepage.categories.official.name'),
        sharingType: t('productComparison.officialTable.sharing.exclusive', '独享'),
        privacy: t('productComparison.privacy'),
        priceValue: '17.9',
        pricePeriod: t('productDetail.common.duration.month'),
        features: {
          canChangePassword: true,
          isExclusive: true
        }
      },
      {
        id: 'official-renewal',
        type: t('homepage.categories.officialRenewal.name'),
        sharingType: t('productComparison.officialTable.sharing.exclusive', '独享'),
        privacy: t('productComparison.privacy'),
        priceValue: '17.9',
        pricePeriod: t('productDetail.common.duration.month'),
        features: {
          canChangePassword: false,
          isRenewal: true
        }
      },
      {
        id: 'official-shared-3',
        type: t('homepage.categories.officialShared.name'),
        sharingType: t('productComparison.officialTable.sharing.shared3', '3人共享'),
        privacy: t('productComparison.officialTable.privacy.sharedVisible', '其他共享用户可见'),
        priceValue: '9.9',
        pricePeriod: t('productDetail.common.duration.month'),
        features: {
          canChangePassword: false,
          sharedUsers: 3
        }
      },
      {
        id: 'official-shared-6',
        type: t('homepage.categories.officialShared.name'),
        sharingType: t('productComparison.officialTable.sharing.shared6', '6人共享'),
        privacy: t('productComparison.officialTable.privacy.sharedVisible', '其他共享用户可见'),
        priceValue: '4.9',
        pricePeriod: t('productDetail.common.duration.month'),
        features: {
          canChangePassword: false,
          sharedUsers: 6
        }
      }
    ]
  };
};

// 保持向后兼容
export const getAllOfficialProductComparisonDataI18n = () => {
  const groupedData = getGroupedOfficialProductComparisonDataI18n();
  return groupedData.variants.map(variant => ({
    ...variant,
    name: groupedData.productName,
    loginMethods: groupedData.loginMethods,
    afterSales: groupedData.afterSales,
    officialPriceValue: groupedData.officialPriceValue,
    officialPricePeriod: groupedData.officialPricePeriod
  }));
};

// 根据产品ID获取单个产品数据
export const getOfficialProductComparisonByIdI18n = (id) => {
  const products = getAllOfficialProductComparisonDataI18n();
  return products.find(product => product.id === id);
};

// 根据类型筛选产品
export const getOfficialProductsByTypeI18n = (type) => {
  const products = getAllOfficialProductComparisonDataI18n();
  return products.filter(product => product.type.includes(type));
};